import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  isLoadingSubject: BehaviorSubject<boolean>;
  private activeLoadings = 0;

  constructor() {
    this.isLoadingSubject = new BehaviorSubject<boolean>(false);
  }

  show(): void {
    this.activeLoadings++;
    this.isLoadingSubject.next(true);
  }

  hide(): void {
    if (this.activeLoadings === 0) {
      return;
    }

    this.activeLoadings--;
    this.isLoadingSubject.next(this.activeLoadings > 0);
  }
}
